import React from 'react';
import { Form, Field } from 'react-final-form';
import { FormField } from '@/shared/ui/form/form-field';
import { Box } from '@/shared/ui/box';
import {
  HeadingRegularQuaternary,
  BodyTextRegularSecondary,
  BodyTextBoldSecondary,
} from '@/shared/ui/typography';

import { useAuth } from '@/features/auth-managment/model/auth-context';
import {
  FormWrapper,
  FormContainer,
  AuthCloseIconImage,
  ButtonContinue,
} from '@/features/auth-managment/styles';
export const CreateRecoveryPassword = () => {
  const {
    onSubmit,
    spinner,
    t,
    currentStep,
    handleClose,
    validateCreatePassword,
  } = useAuth();

  return (
    <FormWrapper $currentStep={currentStep}>
      <FormContainer>
        <Box onClick={handleClose}>
          <AuthCloseIconImage
            width={32}
            height={32}
            src="/images/icons/close-dialog.svg"
          />
        </Box>
        <Box $paddingBottom={16} $textAlign="left" $maxWidth="280px">
          <HeadingRegularQuaternary>
            {t('auth.recover.title')}
          </HeadingRegularQuaternary>
          <Box $paddingTop={8} />
          <BodyTextRegularSecondary color="#AFAFAF">
            {t('auth.recover.desc')}
          </BodyTextRegularSecondary>
        </Box>
        <Form
          validate={validateCreatePassword}
          onSubmit={onSubmit}
          render={({ handleSubmit, submitting, pristine }) => (
            <form onSubmit={handleSubmit}>
              <Box $paddingTop={16}>
                <Field
                  name="password"
                  component={FormField}
                  type="password"
                  placeholder={t('auth.login.password.placeholder')}
                  label={
                    <BodyTextBoldSecondary>
                      {t('auth.recover.password.new')}
                    </BodyTextBoldSecondary>
                  }
                />
              </Box>
              <Box $paddingTop={16}>
                <Field
                  name="confirmPassword"
                  component={FormField}
                  type="password"
                  placeholder={t('auth.login.password.placeholder')}
                  label={
                    <BodyTextBoldSecondary>
                      {t('auth.recover.password.confirm')}
                    </BodyTextBoldSecondary>
                  }
                />
              </Box>
              <Box $paddingTop={24}>
                <ButtonContinue
                  type="submit"
                  disabled={submitting}
                  isLoading={spinner}
                >
                  <BodyTextBoldSecondary>
                    {t('auth.recover.submit')}
                  </BodyTextBoldSecondary>
                </ButtonContinue>
              </Box>
            </form>
          )}
        />
      </FormContainer>
    </FormWrapper>
  );
};
